import axios from '@_system/axios/axios.js'
export default {
	path: '/BIshopgoods',
	get(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	formfield(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path+'/formfield', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listgroup(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/listgroup', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	addgroup(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/addgroup', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	deletegroup(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/deletegroup', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	addOperate(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/addOperate', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	additemtogroup(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/additemtogroup', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	clearitemtogroup(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/clearitemtogroup', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	deleteitemtogroup(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/deleteitemtogroup', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	addgroupkpi(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/addgroupkpi', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listgroupkpi(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/listgroupkpi', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	deletegroupkpi(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/deletegroupkpi', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	cleargroupkpi(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/cleargroupkpi', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	uploadgroupkpi(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/uploadgroupkpi', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},		
			
			
			
	buyerAdvisorOppDetailService(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/buyerAdvisorOppDetailService', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	buyerAdvisorOppRangeService(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/buyerAdvisorOppRangeService', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},			
	getonlineinfo(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/getonlineinfo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	
	
	getOperate(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/getOperate', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	operateFlowup(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/operateFlowup', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	operateDelete(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/operateDelete', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	operateUpdate(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/operateUpdate', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	export(data = {}) {	
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/export', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},			
	downcurrentday(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/downcurrentday', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	itemViewTop(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/itemViewTop', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/Bi.Shopgoods', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	}
}